import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { PerformanceDashboardViewModel } from '../../types';
import { PerformanceAudienceComparisonTable } from '../PerformanceAudienceComparisonTable';
import { PerformanceAudienceKpiRow } from '../PerformanceAudienceKpiRow';
import { PerformanceAudienceStoreVisits } from '../PerformanceAudienceStoreVisits';
import { PerformanceAudienceTrendSection } from '../PerformanceAudienceTrendSection';

type PerformanceDashboardViewProps = PerformanceDashboardViewModel & {
  dateRange: string;
  dateFrom?: string;
  dateTo?: string;
  activeMetric: PerformanceAudienceChartMetric;
  onMetricChange: (metric: PerformanceAudienceChartMetric) => void;
  onEditScope?: () => void;
  onExportCsv?: () => void;
};

export const PerformanceDashboardView: FC<PerformanceDashboardViewProps> = ({ kpis, trend, comparison, storeVisits, activeMetric, onMetricChange }) => {
  return (
    <>
      <PerformanceAudienceKpiRow kpis={kpis} />
      <div className='grid grid-cols-1 gap-[18px] xl:grid-cols-[1.4fr_1fr]'>
        <PerformanceAudienceTrendSection trend={trend} activeMetric={activeMetric} onMetricChange={onMetricChange} />
        <PerformanceAudienceComparisonTable rows={comparison} />
      </div>

      {storeVisits ? <PerformanceAudienceStoreVisits storeVisits={storeVisits} /> : null}
    </>
  );
};
